import { createEnvironmentApi, Environment } from "./environment.schema";

const coreHost = "https://api.dev.qundo.de";
const envTile = "<b style='color:red;'> (DEV: qundo.de)</b>";
export const environment: Environment = {
  api: createEnvironmentApi(coreHost),
  production: true,
  envTile: envTile,
  qrBasicUrl: "https://dev.qundo.de/apps?code=",
};
